module.exports = __webpack_public_path__ + "static/media/green.0416a383.png";